import {OrbitTheme} from '../../architecture/orbit-theme.interface';
import {makeTheme} from '../../make-theme';
import {ThemeName} from '../../architecture/theme-names';
import {MrGreenIcons} from './icons-registry';
import {createGlobalStyle, css} from "styled-components";
import React from "react";
import {baseColors} from "./base-colors";
import {IThemeDefinition} from "../../../services/theme/theme-definition.interface";
import {createMainContentBaseUIComponents} from "./main-content-base-ui-components";
import {createShellBaseUIComponents} from "./shell-base-ui-components";
import {shellGeneralColors} from "./shell-general-colors";
import {mainContentGeneralColors} from "./main-content-general-colors";
import {IFontPresets} from '../../architecture/sections/font-family.interface';
import {HeaderArenasStyle} from "../../architecture/sections/theme-layout.interface";
import {MrGreenThemeCustomizer} from "./theme-customizer";
import {ThemeBoxes} from "./theme.boxes";
import {makeCommonGlobalStyles} from "../common-global-styles";

const GlobalStyles = createGlobalStyle`
  ${makeCommonGlobalStyles()}
  body {
    font-family: "Montserrat", verdana, sans-serif;
    font-weight: 600;
  }

`;

const fontPresets: IFontPresets = {
  thin: css`
      font-family: "Montserrat", verdana, sans-serif;
      font-weight: 100;
  `,
  light: css`
      font-family: "Montserrat", verdana, sans-serif;
      font-weight: 400;
  `,
  regular: css`
      font-family: "Montserrat", verdana, sans-serif;
      font-weight: 500;
  `,
  medium: css`
      font-family: "Montserrat", verdana, sans-serif;
      font-weight: 500;
  `,
  body: css`
      font-family: "Montserrat", verdana, sans-serif;
      font-weight: 500;
  `,
  bold: css`
      font-family: "Montserrat", verdana, sans-serif;
      font-weight: 700;
  `,
  black: css`
      font-family: "Montserrat", verdana, sans-serif;
      font-weight: 800;
  `,
  ultra: css`
      font-family: "Montserrat", verdana, sans-serif;
      font-weight: 700;
  `,
  secondary: css`
      font-family: "Montserrat", verdana, sans-serif;
      font-weight: 700;
  `
};


const MrGreenShellTheme: OrbitTheme = makeTheme({
  generalColors: shellGeneralColors,
  fontPresets,
  baseUIComponents: createShellBaseUIComponents,
  layout: {
    headerArenasStyle: HeaderArenasStyle.Menu
  },
  themeSpecificIcons: MrGreenIcons
});

MrGreenShellTheme.globalStyles = (<GlobalStyles />);

const MrGreenContentTheme: OrbitTheme = makeTheme({
  generalColors: mainContentGeneralColors,
  fontPresets,
  themeSpecificIcons: MrGreenIcons,
  layout: {
    headerArenasStyle: HeaderArenasStyle.Menu
  },
  baseUIComponents: createMainContentBaseUIComponents
})

MrGreenShellTheme.components.header.colors.indicatorBadge.backgroundInGridLayout = baseColors.base05;
MrGreenShellTheme.components.newLiveCasino.colors.filterButtonLabel = shellGeneralColors.textLight;
MrGreenContentTheme.components.header.colors.indicatorBadge.backgroundInGridLayout = mainContentGeneralColors.brandSecondaryLight;
MrGreenContentTheme.components.gamesListTitle.colors.text.regular = mainContentGeneralColors.brandSecondaryDark;
MrGreenContentTheme.components.gamesListTitle.colors.text.dailyJackpot = mainContentGeneralColors.brandSecondaryDark;
MrGreenContentTheme.components.gamesListTitle.colors.text.redTigerJackpot = mainContentGeneralColors.brandSecondaryDark;
MrGreenContentTheme.components.generalTitle.colors.background = mainContentGeneralColors.background;

MrGreenContentTheme.components.newLiveCasino.colors.gridItem.infobarBackground = mainContentGeneralColors.backgroundLight;

MrGreenContentTheme.components.gamingHistory.colors.background = baseColors.gray243;
MrGreenContentTheme.components.gamingHistory.colors.recordBackground = baseColors.white;

const themeDefinition: IThemeDefinition = {
  themeName: ThemeName.MrGreen,
  shellTheme: MrGreenShellTheme,
  mainContentTheme: MrGreenContentTheme,
  popupsTheme: MrGreenContentTheme,
  toastersTheme: MrGreenContentTheme,
  useSquareIconsForGames: true,
  createThemeCustomizer: (services) => new MrGreenThemeCustomizer(services),
  themeBoxes: ThemeBoxes
}


export default themeDefinition;